import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog } from 'src/app/shared/models/app-models/Dialog.model';
import { inject } from '@angular/core/testing';
import { ShareDataService } from '../../services/share-data.service';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  @Input() errMessages!: string[];
  validationErrors: string[] = [];
  constructor(
    public dialogInfoRef: MatDialogRef<DialogComponent>, private sharedService: ShareDataService,
    @Inject(MAT_DIALOG_DATA) public input: Dialog,
  ) {
    console.log('this .errmsgs : ', this.errMessages);
    console.log('the input for infodialog: ', input);
    this.validationErrors = input.errMsgs ?? [];
    /*this.sharedService.consErrorMsgs.subscribe((errMsg) => {
      console.log('validation error msg in dialog: ', errMsg);
      this.validationErrors = errMsg;
    });*/
  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogInfoRef.close();
  }
}
